module.exports = __webpack_public_path__ + "img/cegep-garneau.928ca5b5.png";